const name = "theme";
export default name;
